import { useFleet } from '../state/store'

const TONE: Record<string, string> = {
  warn: 'border-t1/40 bg-t1/10 text-t1',
  error: 'border-t3/50 bg-t3/15 text-[#E0806F]',
  info: 'border-line bg-surface text-muted',
}

/** Degradation is always visible and never blocking: the map stays usable underneath. */
export function Banners(): JSX.Element | null {
  const banners = useFleet((s) => s.banners)
  const dismiss = useFleet((s) => s.dismissBanner)
  if (!banners.length) return null

  return (
    <div className="pointer-events-none absolute left-3 top-3 z-10 flex max-w-[560px] flex-col gap-1.5">
      {banners.map((b) => (
        <div
          key={b.id}
          className={`pointer-events-auto flex items-start gap-3 rounded-sm border px-3 py-2 text-xs backdrop-blur ${TONE[b.tone]}`}
        >
          <span className="flex-1">{b.message}</span>
          <button
            onClick={() => dismiss(b.id)}
            className="shrink-0 opacity-60 transition-opacity hover:opacity-100"
            aria-label="dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
